import "esbuild-css-modules-plugin-ns-css:src/ui/HideUISection.module.css";

export default {
  "hidden": "HideUISection-module__hidden_ygtI5G__0230",
  "hideUiSection": "HideUISection-module__hide-ui-section_ygtI5G__0230",
  "hideUiSectionContents": "HideUISection-module__hide-ui-section-contents_ygtI5G__0230"
};
      